import React from 'react';
import './TransitionSection.css';

const TransitionSection = ({ theme }) => (
  <div className={`transition-gradient theme-${theme}`}></div>
);

export default TransitionSection;
